import { Scale } from '@blade/common/utils/auto-scale';
import colors from '@/styles/color.scss';
const echarts = require('echarts');
export const Legend_Config = {
    textStyle: {
        fontSize: 13 * Scale,
        color: colors.white,
    },
    itemGap: 32,
    itemWidth: 10 * Scale,
    itemHeight: 10 * Scale,
    icon: 'circle',
};
export const Tooltip_Config = {
    textStyle: { fontSize: 14 * Scale, color: colors.loginDialogTitle },
    borderColor: colors.echartlineToole,
    borderWidth: 0,
    extraCssText: `
  box-shadow: 0 0 1px ${colors.taskShadows}, 0 4px 8px ${colors.whiteTransition}; 
  border-radius: 3px; 
  background: ${colors.white};`
};
const AxisLineStyle = { width: Scale, color: colors.echartlinebg5 };
const padSpace = (value) => {
    const str = typeof value === 'number' ? Number(value).toLocaleString() : value;
    return str.padStart(5, ' ');
};
export const interval = (index) => index % 48 === 0 || index === 287; // 12 * 24 -1
export const AxisConfig = {
    axisLabel: {
        fontSize: 12 * Scale,
        color: colors.echartaxiscolor,
        showMaxLabel: true,
        align: 'right',
        interval: 'auto',
        formatter: padSpace
    },
    // splitLine: { lineStyle: { width: AxisLineStyle.width, color: colors.echartlinebg5 } },
    splitLine: { lineStyle: { width: AxisLineStyle.width, color: colors.portraitCenterTextStyleSplitLine } },
    axisLine: { lineStyle: AxisLineStyle },
    axisTick: { show: false }
};
export const BlueItemStyle = {
    normal: {
        areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.8, // 变化度
            [{
                    offset: 0,
                    color: colors.echartlineservice1,
                },
                {
                    offset: 0.3,
                    color: colors.echartlineservice2,
                },
                {
                    offset: 1,
                    color: colors.echartlineservice3,
                }]),
        }
    }
};
export const GreenItemStyle = {
    normal: {
        areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.8, // 变化度
            [{
                    offset: 0,
                    color: colors.echartlineservice4,
                },
                {
                    offset: 0.3,
                    color: colors.echartlineservice5,
                },
                {
                    offset: 1,
                    color: colors.echartlineservice6,
                }]),
        }
    }
};
export const SeriesLineStyle = {
    lineStyle: {
        width: 2 * Scale,
    },
    symbol: 'emptyCircle',
    symbolSize: 4 * Scale,
    showSymbol: false,
};
export const CircleConfig = {
    legend: {
        right: 0,
    },
    series: {
        center: [46 * Scale, 46 * Scale],
    }
};
